import { render } from "./homeCategory.vue?vue&type=template&id=773e63db"
import script from "./homeCategory.vue?vue&type=script&lang=js"
export * from "./homeCategory.vue?vue&type=script&lang=js"

import "./homeCategory.vue?vue&type=style&index=0&id=773e63db&lang=scss"

import exportComponent from "/home/jenkins/workspace/CIS-school.vip.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__